/* eslint-disable react/jsx-props-no-spreading */
import { PropTypes } from "prop-types";
import { Route, Redirect } from "react-router-dom";
import { AuthState } from "@aws-amplify/ui-components";
import { useAuth } from "../hooks/useAuth";
import { HOME, LOGIN } from "../constants/routes";

const propTypes = {
  allowedGroups: PropTypes.objectOf(PropTypes.string).isRequired,
  children: PropTypes.node.isRequired,
};

const PrivateRoute = ({ allowedGroups, children, ...rest }) => {
  const auth = useAuth();
  const isUserInAllowedGroups = () =>
    auth.userGroups.current.some((group) => allowedGroups.has(group));

  const routeAuthenticatedUser = () => {
    if (isUserInAllowedGroups) {
      return children;
    }
    return <Redirect to={{ pathname: HOME }} />;
  };

  return (
    <Route
      {...rest}
      render={({ location }) =>
        auth.authState === AuthState.SignedIn && auth.user ? (
          routeAuthenticatedUser()
        ) : (
          <Redirect
            to={{
              pathname: LOGIN,
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

PrivateRoute.propTypes = propTypes;

export default PrivateRoute;
